/**
 * Constants for the Account Settings screen.
 *
 * Centralised here so the orchestrator, the dumb element components, and any
 * deep-link / redirect path agree on the same labels, validation rules, and
 * timings.
 */

export const PAGE_METADATA = {
    title: { text: 'Account', highlight: 'Settings' },
    description: 'Manage your account information and preferences.',
};

export const ROLE_LABEL_FALLBACK = 'Member';

// Minimum length enforced by the password reset endpoint. Mirrored here so
// the client can short-circuit obvious invalid submissions.
export const PASSWORD_MIN_LENGTH = 8;

export const ERROR_MESSAGES = Object.freeze({
    CURRENT_PASSWORD_REQUIRED: 'Please enter your current password.',
    PASSWORDS_DO_NOT_MATCH: 'New passwords do not match.',
    PASSWORD_TOO_SHORT: `New password must be at least ${PASSWORD_MIN_LENGTH} characters.`,
    UPDATE_FAILED: 'Failed to update account. Please try again.',
    PARTIAL_UPDATE_FAILED:
        'Your password was updated, but we could not save your profile changes. Please refresh and try again.',
});

export const SUCCESS_MESSAGE = 'Account updated successfully';

// How long the success banner stays on-screen before the orchestrator
// redirects back to the dashboard.
export const REDIRECT_DELAY_MS = 2000;
